import { useLayoutEffect } from 'react'

const BODY_SCOPE_CLASS = 'mfe-informes-active'

export function activateMicrofrontendStyleScope(classList) {
  classList.add(BODY_SCOPE_CLASS)
  return () => classList.remove(BODY_SCOPE_CLASS)
}

export default function useMicrofrontendStyleScope() {
  useLayoutEffect(() => {
    if (typeof document === 'undefined') return undefined
    return activateMicrofrontendStyleScope(document.body.classList)
  }, [])
}
